import { render } from "./HeaderNotFound.vue?vue&type=template&id=543020c6"
import script from "./HeaderNotFound.vue?vue&type=script&lang=js"
export * from "./HeaderNotFound.vue?vue&type=script&lang=js"

import "./HeaderNotFound.vue?vue&type=style&index=0&id=543020c6&lang=css"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__